import React, { useState, useEffect } from "react";
import { TableHeadersType } from "../../../../constant/tableHeadersConstants/tableHeadersType";
import { AllLedgersListType } from "../../../../redux/clientSettings/clientSettingTypes";
import { formateDateTime } from "../../../../utils/commonFunctions";
import UpdatedByAndUpdatedAt from "../../../commons/CommonUpdatedByAndUpdatedAt";
import TableToggleSwitch from "../../../commons/TableToggleSwitch";

type AppProps = {
  data: AllLedgersListType[] | [];
  tableHeader: TableHeadersType[];
  handleEditAccountDetails: (data: AllLedgersListType) => void;
  isEditAccountPresent: boolean;
  handleEnableDisableStatus:(data:any)=>void;
  isChangeStatusCustomerSupplierPresent:boolean;
};

const AccountsManagerTableData = ({
  data,
  tableHeader,
  handleEditAccountDetails,
  isEditAccountPresent,
  handleEnableDisableStatus,
  isChangeStatusCustomerSupplierPresent
}: AppProps) => {
  const [finalLedgerList, setFinalLedgerList] = useState<any>([]);

  useEffect(() => {
    if (data?.length > 0) manipulateData(data);
     //eslint-disable-next-line
  }, [data]);

  const getLedgerTypeName = (ledgerType: string) => {
    switch (ledgerType) {
      case "nature_of_expense":
        return "Expense";
      case "nature_of_income":
        return "Income";
      case "payment":
        return "Cash & Cash Equivalents";
      case "assets":
        return "Assets";
      case "liabilities":
        return "Liabilities";
      case "equity":
        return "Equity";
      default:
        return "Expense";
    }
  };

  const getLedgerLevel = (ledgerLevel: number) => {
    switch (ledgerLevel) {
      case 1:
        return "ledger-list-first";
      case 2:
        return "ledger-list-second";
      case 3:
        return "ledger-list-third";
      case 4:
        return "ledger-list-fourth";
      default:
        return null;
    }
  };

  const manipulateData = (data: any) => {
    let finalData: any = [];
    data?.map((tempData: any) => {
      finalData.push({
        level: 1,
        ledger_number: tempData?.ledger_number,
        ledger_name: tempData?.ledger_name,
        ledger_type: getLedgerTypeName(tempData?.ledger_type),
        ledger_tech_type: tempData?.ledger_type,
        ledger_id: tempData?.ledger_id,
        parentAccount: "",
        updated_at: tempData?.updated_at,
        parent_id: tempData?.parent_id,
        to_show: tempData?.to_show,
        cog_type: tempData?.cog_type,
        is_tree: tempData?.is_tree,
        updated_by:tempData?.updated_by,
        is_disabled:tempData?.is_disabled
      });
      if (tempData?.is_tree) {
        tempData?.tree_data?.map((tree: any) => {
          finalData.push({
            level: 2,
            ledger_number: tree?.ledger_number,
            ledger_name: tree?.ledger_name,
            ledger_type: getLedgerTypeName(tree?.ledger_type),
            ledger_tech_type: tree?.ledger_type,
            ledger_id: tree?.ledger_id,
            parentAccount: tempData?.ledger_name,
            updated_at: tree?.updated_at,
            parent_id: tree?.parent_id,
            to_show: tree?.to_show,
            cog_type: tree?.cog_type,
            is_tree: tempData?.is_tree,
            updated_by:tree?.updated_by,
            is_disabled:tree?.is_disabled
          });
          if (tree?.is_tree) {
            tree?.tree_data?.map((treeD: any) => {
              finalData.push({
                level: 3,
                ledger_number: treeD?.ledger_number,
                ledger_name: treeD?.ledger_name,
                ledger_type: getLedgerTypeName(treeD?.ledger_type),
                ledger_tech_type: treeD?.ledger_type,
                ledger_id: treeD?.ledger_id,
                parentAccount: tree?.ledger_name,
                updated_at: treeD?.updated_at,
                parent_id: treeD?.parent_id,
                to_show: treeD?.to_show,
                cog_type: treeD?.cog_type,
                is_tree: tempData?.is_tree,
                updated_by:treeD?.updated_by,
                is_disabled:treeD?.is_disabled
              });
              if (treeD?.is_tree) {
                treeD?.tree_data?.map((treeD1: any) => {
                  finalData.push({
                    level: 4,
                    ledger_number: treeD1?.ledger_number,
                    ledger_name: treeD1?.ledger_name,
                    ledger_type: getLedgerTypeName(treeD1?.ledger_type),
                    ledger_tech_type: treeD1?.ledger_type,
                    ledger_id: treeD1?.ledger_id,
                    parentAccount: treeD?.ledger_name,
                    updated_at: treeD1?.updated_at,
                    parent_id: treeD1?.parent_id,
                    to_show: treeD1?.to_show,
                    cog_type: treeD1?.cog_type,
                    is_tree: tempData?.is_tree,
                    updated_by:treeD1?.updated_by,
                    is_disabled:treeD1?.is_disabled
                  });
                });
              }
            });
          }
        });
      }
    });

    setFinalLedgerList(finalData);
  };

  const renderTableData = () => {
    const finalTableData = finalLedgerList?.map((dataItem: any) => {
      return (
        <tr key={dataItem?.ledger_id} className="text-left">
          {tableHeader?.length &&
            tableHeader?.map((header: TableHeadersType) => {
              if (header.value === "ledger_name") {
                return (
                  <td>
                    <span
                      className={`${getLedgerLevel(dataItem?.level)} ${!dataItem?.to_show && "no-show"
                        }`}
                    >
                      {dataItem?.ledger_name}
                    </span>
                  </td>
                );
              } else if (header.value === "ledger_number") {
                return (
                  <td style={{ width: "150px" }}>{dataItem?.ledger_number}</td>
                );
              } else if (header.value === "ledger_type") {
                return <td className="">{dataItem?.ledger_type}</td>;
              } else if (header.value === "parentAccount") {
                return <td>{dataItem?.parentAccount}</td>;
              } 
              else if (header.value === "status") {
                return (
                  isChangeStatusCustomerSupplierPresent &&
                  <TableToggleSwitch
                    handleEnableDisableClick={handleEnableDisableStatus}
                    status={dataItem?.is_disabled === 0 ? true :false}
                    tableData={dataItem}
                  />
                );
              }
              else if (header.value === "updated_by") {
                return (
                  <td style={{width:'180px'}}>
                  <UpdatedByAndUpdatedAt
                   firstName={dataItem?.updated_by?.first_name}
                   lastName={dataItem?.updated_by?.last_name}
                   profilePic={dataItem?.updated_by?.profile_pic?.file_url}
                   updatedAt={formateDateTime(dataItem?.updated_at)}
       />
                 
               </td>
                );
              } else {
                return <td> --/-- </td>;
              }
            })}
          <td style={{ width: "80px", textAlign: "center" }}>
            {isEditAccountPresent && <span
              className="d-inline-block pointer"
              onClick={() => handleEditAccountDetails(dataItem)}
            >
              <div
                style={{
                  color: "#d43",
                  fontSize: 20,
                }}
              >
                <i className="fas fa-pen"></i>
              </div>
            </span>}
          </td>
        </tr>
      );
    });

    return finalTableData;
  };

  return <>{renderTableData()}</>;
};

export default AccountsManagerTableData;
